import React from 'react';
import { Line } from 'react-chartjs-2';
import { Activity } from 'lucide-react';

export function ClientProgressChart() {
  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    datasets: [
      {
        label: 'Strength Progress',
        data: [65, 72, 78, 75, 82, 88],
        borderColor: 'hsl(var(--primary))',
        tension: 0.4
      },
      {
        label: 'Endurance Progress',
        data: [70, 75, 72, 80, 85, 82],
        borderColor: 'hsl(var(--success))',
        tension: 0.4
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100
      }
    }
  };

  return (
    <div className="theme-card p-6">
      <div className="flex items-center gap-3 mb-6">
        <Activity className="w-5 h-5 text-primary" />
        <h2 className="text-lg font-semibold">Client Progress Overview</h2>
      </div>
      <div className="h-[300px]">
        <Line data={data} options={options} />
      </div>
    </div>
  );
}